// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commonSwiperNavigationBtn {
    background: var(--primary-white-bg);
    color: var(--common-text-color);
    box-shadow: 0px 0px 4px 0px #b9b9b9;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    cursor: pointer;
    z-index: 1;
}

.popularLocationSwiperNavigationNextBtn,
.popularLocationSwiperNavigationPrevBtn {
    position: absolute;
    top: calc(112px - 30px);
}

.popularLocationSwiperNavigationNextBtn {
    right: -20px;
}

.popularLocationSwiperNavigationPrevBtn {
    left: -20px;
}


/* most review and recommended slider start */
.mostReviewSwiperNavigationNextBtn,
.mostReviewSwiperNavigationPrevBtn,
.recommendedSwiperNavigationPrevBtn,
.recommendedSwiperNavigationNextBtn,
.viewProfileSwiperNavigationPrevBtn,
.viewProfileSwiperNavigationNextBtn,
.similarListSwiperNavigationNextBtn,
.similarListSwiperNavigationPrevBtn {
    position: absolute;
    top: 40%;
}

.mostReviewSwiperNavigationNextBtn,
.recommendedSwiperNavigationNextBtn,
.viewProfileSwiperNavigationNextBtn {
    right: -20px;
}

.similarListSwiperNavigationNextBtn {
    right: -15px;
}

.mostReviewSwiperNavigationPrevBtn,
.recommendedSwiperNavigationPrevBtn,
.viewProfileSwiperNavigationPrevBtn {
    left: -20px;
}

.similarListSwiperNavigationPrevBtn {
    left: -15px;
}

.mostReviewSwiperNavigationNextBtn.swiper-button-disabled,
.mostReviewSwiperNavigationPrevBtn.swiper-button-disabled,
.recommendedSwiperNavigationNextBtn.swiper-button-disabled,
.recommendedSwiperNavigationPrevBtn.swiper-button-disabled,
.viewProfileSwiperNavigationPrevBtn.swiper-button-disabled,
.viewProfileSwiperNavigationNextBtn.swiper-button-disabled,
.similarListSwiperNavigationPrevBtn.swiper-button-disabled,
.similarListSwiperNavigationNextBtn.swiper-button-disabled,
.servicePlanSwiperNavPrevBtn.swiper-button-disabled,
.servicePlanSwiperNavNextBtn.swiper-button-disabled,
.popularLocationSwiperNavigationNextBtn.swiper-button-disabled,
.popularLocationSwiperNavigationPrevBtn.swiper-button-disabled {
    display: none;
}



/* service plan swiper */
.dummyLastServicePlanSwiper {
    width: 0px;
    display: none;
}

.servicePlanSwiper {
    height: auto !important;
}

.servicePlanSwiperNavPrevBtn,
.servicePlanSwiperNavNextBtn {
    position: absolute;
    top: 145px;
    background: var(--primary-white-bg);
    color: var(--primary-foreground);
    width: 40px;
    height: 40px;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    z-index: 1;
    transition: all .2s linear;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary-border);
    padding: 0;
}

.servicePlanSwiperNavPrevBtn {
    left: 0;
    box-shadow: -1.74px 0.87px 3.48px #2727273B;
}

.servicePlanSwiperNavNextBtn {
    right: 0;
    box-shadow: 1.74px 0.87px 3.48px #2727273B;
}


/* most review and recommended slider end */

.claimImageSwiperNavigationPrevBtn,
.claimImageSwiperNavigationNextBtn {
    position: absolute;
    top: 50%;
    background: #fff;
    box-shadow: 0px 0px 4px 0px #484848;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    transform: translateY(-50%);
    z-index: 1;
    cursor: pointer;
}

.claimImageSwiperNavigationPrevBtn svg,
.claimImageSwiperNavigationNextBtn svg {
    width: 12px;
    height: 12px;
}

.claimImageSwiperNavigationPrevBtn {
    left: -8px;
}

.claimImageSwiperNavigationNextBtn {
    right: -8px;
}

.claimImageSwiperNavigationPrevBtn.swiper-button-disabled,
.claimImageSwiperNavigationNextBtn.swiper-button-disabled {
    display: none;
}


/* rtl swiper */
.rtl .popularLocationSwiperNavigationNextBtn {
    right: unset;
    left: -20px;
}

.rtl .popularLocationSwiperNavigationPrevBtn {
    left: unset;
    right: -20px;
}

.rtl .popularLocationSwiperNavigationNextBtn svg,
.rtl .popularLocationSwiperNavigationPrevBtn svg {
    transform: rotate(180deg);
}

.rtl .mostReviewSwiperNavigationNextBtn,
.rtl .recommendedSwiperNavigationNextBtn,
.rtl .viewProfileSwiperNavigationNextBtn {
    right: unset;
    left: -20px;
}

.rtl .mostReviewSwiperNavigationPrevBtn,
.rtl .recommendedSwiperNavigationPrevBtn,
.rtl .viewProfileSwiperNavigationPrevBtn {
    left: unset;
    right: -20px;
}

.rtl .mostReviewSwiperNavigationNextBtn svg,
.rtl .recommendedSwiperNavigationNextBtn svg,
.rtl .viewProfileSwiperNavigationNextBtn svg,
.rtl .mostReviewSwiperNavigationPrevBtn svg,
.rtl .recommendedSwiperNavigationPrevBtn svg,
.rtl .viewProfileSwiperNavigationPrevBtn svg {
    transform: rotate(180deg);
}

.rtl .similarListSwiperNavigationNextBtn {
    right: unset;
    left: -15px;
}

.rtl .similarListSwiperNavigationPrevBtn {
    left: unset;
    right: -15px;
}

.rtl .similarListSwiperNavigationNextBtn svg,
.rtl .similarListSwiperNavigationPrevBtn svg,
.rtl .servicePlanSwiperNavPrevBtn svg,
.rtl .servicePlanSwiperNavNextBtn svg {
    transform: rotate(180deg);
}

.rtl .servicePlanSwiperNavNextBtn {
    left: 0;
    right: unset;
    box-shadow: -1.74px 0.87px 3.48px #2727273B;
}

.rtl .servicePlanSwiperNavPrevBtn {
    right: 0;
    left: unset;
    box-shadow: 1.74px 0.87px 3.48px #2727273B;
}


/* media query */
@media (min-width:576px) {
    .servicePlanSwiper {
        max-width: 300px;
    }

    .dummyLastServicePlanSwiper {
        width: 20px;
        display: block;
    }

    .servicePlanSwiperNavNextBtn {
        transform: translate(-25%, 50%);
    }

    .servicePlanSwiperNavPrevBtn {
        transform: translate(25%, 50%);
    }

    /* rtl */
    .rtl .servicePlanSwiperNavNextBtn {
        transform: translate(25%, 50%);
    }

    .rtl .servicePlanSwiperNavPrevBtn {
        transform: translate(-25%, 50%);
    }
}

@media (max-width:575px) {
    .servicePlanSwiperNavPrevBtn {
        transform: translate(0, 50%);
    }

    .servicePlanSwiperNavNextBtn {
        transform: translate(0, 50%);
    }


}

@media (max-width: 991px) and (min-width: 768px) {

    .viewProfileSwiperNavigationPrevBtn,
    .viewProfileSwiperNavigationNextBtn,
    .similarListSwiperNavigationPrevBtn,
    .similarListSwiperNavigationNextBtn {
        top: 28%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/customSwiper.css"],"names":[],"mappings":"AAAA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,UAAU;AACd;;AAEA;;IAEI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;;AAGA,6CAA6C;AAC7C;;;;;;;;IAQI,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;;;IAGI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;;;IAGI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;;;;;;;;;;;;IAYI,aAAa;AACjB;;;;AAIA,wBAAwB;AACxB;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;IACV,mCAAmC;IACnC,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uCAAuC;IACvC,UAAU;AACd;;AAEA;IACI,OAAO;IACP,2CAA2C;AAC/C;;AAEA;IACI,QAAQ;IACR,0CAA0C;AAC9C;;;AAGA,2CAA2C;;AAE3C;;IAEI,kBAAkB;IAClB,QAAQ;IACR,gBAAgB;IAChB,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,UAAU;IACV,eAAe;AACnB;;AAEA;;IAEI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;;IAEI,aAAa;AACjB;;;AAGA,eAAe;AACf;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;;;IAGI,YAAY;IACZ,WAAW;AACf;;AAEA;;;IAGI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;;;IAMI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;;IAII,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,2CAA2C;AAC/C;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,0CAA0C;AAC9C;;;AAGA,gBAAgB;AAChB;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,+BAA+B;IACnC;;IAEA;QACI,8BAA8B;IAClC;;IAEA,QAAQ;IACR;QACI,8BAA8B;IAClC;;IAEA;QACI,+BAA+B;IACnC;AACJ;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,4BAA4B;IAChC;;;AAGJ;;AAEA;;IAEI;;;;QAII,QAAQ;IACZ;AACJ","sourcesContent":[".commonSwiperNavigationBtn {\n    background: var(--primary-white-bg);\n    color: var(--common-text-color);\n    box-shadow: 0px 0px 4px 0px #b9b9b9;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 46px;\n    height: 46px;\n    cursor: pointer;\n    z-index: 1;\n}\n\n.popularLocationSwiperNavigationNextBtn,\n.popularLocationSwiperNavigationPrevBtn {\n    position: absolute;\n    top: calc(112px - 30px);\n}\n\n.popularLocationSwiperNavigationNextBtn {\n    right: -20px;\n}\n\n.popularLocationSwiperNavigationPrevBtn {\n    left: -20px;\n}\n\n\n/* most review and recommended slider start */\n.mostReviewSwiperNavigationNextBtn,\n.mostReviewSwiperNavigationPrevBtn,\n.recommendedSwiperNavigationPrevBtn,\n.recommendedSwiperNavigationNextBtn,\n.viewProfileSwiperNavigationPrevBtn,\n.viewProfileSwiperNavigationNextBtn,\n.similarListSwiperNavigationNextBtn,\n.similarListSwiperNavigationPrevBtn {\n    position: absolute;\n    top: 40%;\n}\n\n.mostReviewSwiperNavigationNextBtn,\n.recommendedSwiperNavigationNextBtn,\n.viewProfileSwiperNavigationNextBtn {\n    right: -20px;\n}\n\n.similarListSwiperNavigationNextBtn {\n    right: -15px;\n}\n\n.mostReviewSwiperNavigationPrevBtn,\n.recommendedSwiperNavigationPrevBtn,\n.viewProfileSwiperNavigationPrevBtn {\n    left: -20px;\n}\n\n.similarListSwiperNavigationPrevBtn {\n    left: -15px;\n}\n\n.mostReviewSwiperNavigationNextBtn.swiper-button-disabled,\n.mostReviewSwiperNavigationPrevBtn.swiper-button-disabled,\n.recommendedSwiperNavigationNextBtn.swiper-button-disabled,\n.recommendedSwiperNavigationPrevBtn.swiper-button-disabled,\n.viewProfileSwiperNavigationPrevBtn.swiper-button-disabled,\n.viewProfileSwiperNavigationNextBtn.swiper-button-disabled,\n.similarListSwiperNavigationPrevBtn.swiper-button-disabled,\n.similarListSwiperNavigationNextBtn.swiper-button-disabled,\n.servicePlanSwiperNavPrevBtn.swiper-button-disabled,\n.servicePlanSwiperNavNextBtn.swiper-button-disabled,\n.popularLocationSwiperNavigationNextBtn.swiper-button-disabled,\n.popularLocationSwiperNavigationPrevBtn.swiper-button-disabled {\n    display: none;\n}\n\n\n\n/* service plan swiper */\n.dummyLastServicePlanSwiper {\n    width: 0px;\n    display: none;\n}\n\n.servicePlanSwiper {\n    height: auto !important;\n}\n\n.servicePlanSwiperNavPrevBtn,\n.servicePlanSwiperNavNextBtn {\n    position: absolute;\n    top: 145px;\n    background: var(--primary-white-bg);\n    color: var(--primary-foreground);\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    text-align: center;\n    cursor: pointer;\n    z-index: 1;\n    transition: all .2s linear;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary-border);\n    padding: 0;\n}\n\n.servicePlanSwiperNavPrevBtn {\n    left: 0;\n    box-shadow: -1.74px 0.87px 3.48px #2727273B;\n}\n\n.servicePlanSwiperNavNextBtn {\n    right: 0;\n    box-shadow: 1.74px 0.87px 3.48px #2727273B;\n}\n\n\n/* most review and recommended slider end */\n\n.claimImageSwiperNavigationPrevBtn,\n.claimImageSwiperNavigationNextBtn {\n    position: absolute;\n    top: 50%;\n    background: #fff;\n    box-shadow: 0px 0px 4px 0px #484848;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    transform: translateY(-50%);\n    z-index: 1;\n    cursor: pointer;\n}\n\n.claimImageSwiperNavigationPrevBtn svg,\n.claimImageSwiperNavigationNextBtn svg {\n    width: 12px;\n    height: 12px;\n}\n\n.claimImageSwiperNavigationPrevBtn {\n    left: -8px;\n}\n\n.claimImageSwiperNavigationNextBtn {\n    right: -8px;\n}\n\n.claimImageSwiperNavigationPrevBtn.swiper-button-disabled,\n.claimImageSwiperNavigationNextBtn.swiper-button-disabled {\n    display: none;\n}\n\n\n/* rtl swiper */\n.rtl .popularLocationSwiperNavigationNextBtn {\n    right: unset;\n    left: -20px;\n}\n\n.rtl .popularLocationSwiperNavigationPrevBtn {\n    left: unset;\n    right: -20px;\n}\n\n.rtl .popularLocationSwiperNavigationNextBtn svg,\n.rtl .popularLocationSwiperNavigationPrevBtn svg {\n    transform: rotate(180deg);\n}\n\n.rtl .mostReviewSwiperNavigationNextBtn,\n.rtl .recommendedSwiperNavigationNextBtn,\n.rtl .viewProfileSwiperNavigationNextBtn {\n    right: unset;\n    left: -20px;\n}\n\n.rtl .mostReviewSwiperNavigationPrevBtn,\n.rtl .recommendedSwiperNavigationPrevBtn,\n.rtl .viewProfileSwiperNavigationPrevBtn {\n    left: unset;\n    right: -20px;\n}\n\n.rtl .mostReviewSwiperNavigationNextBtn svg,\n.rtl .recommendedSwiperNavigationNextBtn svg,\n.rtl .viewProfileSwiperNavigationNextBtn svg,\n.rtl .mostReviewSwiperNavigationPrevBtn svg,\n.rtl .recommendedSwiperNavigationPrevBtn svg,\n.rtl .viewProfileSwiperNavigationPrevBtn svg {\n    transform: rotate(180deg);\n}\n\n.rtl .similarListSwiperNavigationNextBtn {\n    right: unset;\n    left: -15px;\n}\n\n.rtl .similarListSwiperNavigationPrevBtn {\n    left: unset;\n    right: -15px;\n}\n\n.rtl .similarListSwiperNavigationNextBtn svg,\n.rtl .similarListSwiperNavigationPrevBtn svg,\n.rtl .servicePlanSwiperNavPrevBtn svg,\n.rtl .servicePlanSwiperNavNextBtn svg {\n    transform: rotate(180deg);\n}\n\n.rtl .servicePlanSwiperNavNextBtn {\n    left: 0;\n    right: unset;\n    box-shadow: -1.74px 0.87px 3.48px #2727273B;\n}\n\n.rtl .servicePlanSwiperNavPrevBtn {\n    right: 0;\n    left: unset;\n    box-shadow: 1.74px 0.87px 3.48px #2727273B;\n}\n\n\n/* media query */\n@media (min-width:576px) {\n    .servicePlanSwiper {\n        max-width: 300px;\n    }\n\n    .dummyLastServicePlanSwiper {\n        width: 20px;\n        display: block;\n    }\n\n    .servicePlanSwiperNavNextBtn {\n        transform: translate(-25%, 50%);\n    }\n\n    .servicePlanSwiperNavPrevBtn {\n        transform: translate(25%, 50%);\n    }\n\n    /* rtl */\n    .rtl .servicePlanSwiperNavNextBtn {\n        transform: translate(25%, 50%);\n    }\n\n    .rtl .servicePlanSwiperNavPrevBtn {\n        transform: translate(-25%, 50%);\n    }\n}\n\n@media (max-width:575px) {\n    .servicePlanSwiperNavPrevBtn {\n        transform: translate(0, 50%);\n    }\n\n    .servicePlanSwiperNavNextBtn {\n        transform: translate(0, 50%);\n    }\n\n\n}\n\n@media (max-width: 991px) and (min-width: 768px) {\n\n    .viewProfileSwiperNavigationPrevBtn,\n    .viewProfileSwiperNavigationNextBtn,\n    .similarListSwiperNavigationPrevBtn,\n    .similarListSwiperNavigationNextBtn {\n        top: 28%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
